module.exports = {"login":{"signin":"ลงชื่อเข้าใช้ด้วย o365","title":"ลงชื่อเข้าใช้","logout":"ลงชื่อออก","loginFail":"ลงชื่อเข้าใช้งาน ไม่สำเร็จ","getUserInfoFail":"ดึงข้อมูลจาก Microsoft Graph ไม่สำเร็จ"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/login.json
// module id = 558
// module chunks = 35